import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

import CertificateStep01 from "../../../../module/contracter/step/CertificateStep01";
import CertificateStep02 from "../../../../module/contracter/step/CertificateStep02";
import CertificateStep03 from "../../../../module/contracter/step/CertificateStep03";
import CertificateStep04 from "../../../../module/contracter/step/CertificateStep04";
import CertificateStep05 from "../../../../module/contracter/step/CertificateStep05";
import {alertActions, contracterActions } from "../../../../store/actions";
import PopupGetItem from "../../../../module/contracter/PopupGetItem";
import history from "../../../../route/history";

import ServiceDashboard from '../../../../layout/service/ServiceDashBoard' // 2021.05 DashBoard 추가

const CertificateApply = props => {
  let [paramKey, setParamKey] = useState();
  let [value, setValue] = useState();
  let [step, setStep] = useState(props.match.params.step)

  /**
   * 수정정보 조회
   */
  useEffect(() => {
    let paramValue = props.location?.search?.split("=")[1];
    let paramKey =  props.location?.search?.split("=")[0];

    paramKey && setParamKey(paramKey);
    paramValue && setValue(paramValue);
    
    if (paramKey === '?seq' && paramValue) {
      props.load(paramValue);
    }
  }, [])

  /**
   * 수정정보 조회 콜백
   */
  useEffect(() => {
    if (paramKey === "?seq" && props.totalData?.step1?.docid?.length > 0) {
      console.log(props.totalData);
      sessionStorage.setItem(props.totalData?.step1?.docid, JSON.stringify(props.totalData));
      window.location.replace('/service/apply/1?id=' + props.totalData?.step1.docid);
    }

  }, [props.totalData])

  /**
   * 문서 삭제 콜백
   */
  useEffect(() => {
    if (props.isDelete === true) {
      sessionStorage.removeItem(value);
      window.location.replace('/service/inbox');
    }
  }, [props.isDelete])


  useEffect(() => {
    if (props.isSend === true) {
      let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq;
      sessionStorage.removeItem(value);
      window.location.replace('/service/apply/detail/' + key);
    }
  }, [props.isSend])

  /**
   * 스탭정보 세팅
   */
  useEffect(() => {
    setStep(props.match.params.step);
  }, [props.match.params.step])


  /**
   * 다음화면 진입을 위한 유효성 체크
   */
  const goStepNext = () => {
    let totalData = JSON.parse(sessionStorage.getItem(value));

    if (totalData["step" + step]?.length <= 0) {
      return props.error({message: '목록을 등록해주세요.'});
    }

    history.push('/service/apply/' + (parseInt(step) + 1) + '?id=' + value);
  }

  /**
   * 문서 삭제처리
   */
  const doDelete = () => {
    if (paramKey === "?id" && value) {
      props.confirm({
        title: '확인',
        message: '문서를 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq;
            key && props.deleteDoc(key);
          }
        }
      })
    }
  }

  const doIssue = () => {
    props.confirm({
      title: '확인',
      message: '발급신청을 하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq;
          props.issueDoc(key);
        }
      }
    })

  }

  return(
    <React.Fragment>
        <div className="ServiceDashboard">
          <ServiceDashboard />
          { /*dash board */ }
        </div>

        <div className="step-box">
          <ul className="flex-c-m">
            <li className={step === "1" ? 'active' : ''}> <span className="stepName">일반정보</span></li> {/* [complete]이전단계,  [active]현재 */}
            <li className={step === "2" ? 'active' : ''}> <span className="stepName">구매물품</span></li>
            <li className={step === "3" ? 'active' : ''}> <span className="stepName">수출근거서류</span></li>
            <li className={step === "4" ? 'active' : ''}> <span className="stepName">세금계산서</span></li>
            <li className={step === "5" ? 'active' : ''}> <span className="stepName">발급신청</span></li>
          </ul>
        </div>

      <div className="detail-table">
        <div className="service-title">구매확인서 발급 신청</div>

        { step === "1" && <CertificateStep01 passData={props.location.state} search={props.location?.search} doDelete={doDelete} /> }
        { step === "2" && <CertificateStep02 passData={props.location.state} search={props.location?.search} doDelete={doDelete} goStepNext={goStepNext}/> }
        { step === "3" && <CertificateStep03 passData={props.location.state} search={props.location?.search} doDelete={doDelete} goStepNext={goStepNext}/> }
        { step === "4" && <CertificateStep04 passData={props.location.state} search={props.location?.search} doDelete={doDelete} goStepNext={goStepNext}/> }
        { step === "5" && <CertificateStep05 passData={props.location.state} search={props.location?.search} doDelete={doDelete} doIssue={doIssue} /> }
      </div>
        { props.isShowItems === true && <PopupGetItem docid={value} />}

    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    totalData: state.contracter.data,
    isShowItems: state.contracter.isShowItems,
    isDelete: state.contracter.isDelete,
    isSend: state.contracter.isSend,
  }
}

const actionCreators = {
  load: contracterActions.load,
  error: alertActions.error,
  confirm : alertActions.confirm,
  deleteDoc : contracterActions.deleteTempDoc,
  issueDoc: contracterActions.issueDoc,
}

export default connect(
    mapStateToProps,
    actionCreators
)(CertificateApply)
